"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityMemberRemovedEvent = exports.CommunityMemberBannedEvent = exports.CommunityRenamedEvent = exports.CommunityDeletedEvent = void 0;
const validation_1 = require("../../validation");
const base_1 = require("./base");
var CommunityDeletedEvent;
(function (CommunityDeletedEvent) {
    CommunityDeletedEvent.schema = {
        type: 'object',
        properties: {
            type: { type: 'string', const: base_1.Events.Type.COMMUNITY },
            subType: { type: 'string', const: base_1.Events.SubType.Community.DELETED },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 1 },
            metadata: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    name: { type: 'string' },
                    memberAddresses: { type: 'array', items: { type: 'string' } },
                    thumbnailUrl: { type: 'string' }
                },
                required: ['id', 'name', 'memberAddresses', 'thumbnailUrl'],
                additionalProperties: false
            }
        },
        required: ['type', 'subType', 'key', 'timestamp', 'metadata'],
        additionalProperties: false
    };
    CommunityDeletedEvent.validate = (0, validation_1.generateLazyValidator)(CommunityDeletedEvent.schema);
})(CommunityDeletedEvent = exports.CommunityDeletedEvent || (exports.CommunityDeletedEvent = {}));
var CommunityRenamedEvent;
(function (CommunityRenamedEvent) {
    CommunityRenamedEvent.schema = {
        type: 'object',
        properties: {
            type: { type: 'string', const: base_1.Events.Type.COMMUNITY },
            subType: { type: 'string', const: base_1.Events.SubType.Community.RENAMED },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 1 },
            metadata: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    oldName: { type: 'string' },
                    newName: { type: 'string' },
                    memberAddresses: { type: 'array', items: { type: 'string' } },
                    thumbnailUrl: { type: 'string' }
                },
                required: ['id', 'oldName', 'newName', 'memberAddresses', 'thumbnailUrl'],
                additionalProperties: false
            }
        },
        required: ['type', 'subType', 'key', 'timestamp', 'metadata'],
        additionalProperties: false
    };
    CommunityRenamedEvent.validate = (0, validation_1.generateLazyValidator)(CommunityRenamedEvent.schema);
})(CommunityRenamedEvent = exports.CommunityRenamedEvent || (exports.CommunityRenamedEvent = {}));
var CommunityMemberBannedEvent;
(function (CommunityMemberBannedEvent) {
    CommunityMemberBannedEvent.schema = {
        type: 'object',
        properties: {
            type: { type: 'string', const: base_1.Events.Type.COMMUNITY },
            subType: { type: 'string', const: base_1.Events.SubType.Community.MEMBER_BANNED },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 1 },
            metadata: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    name: { type: 'string' },
                    memberAddress: { type: 'string' },
                    thumbnailUrl: { type: 'string' }
                },
                required: ['id', 'name', 'memberAddress', 'thumbnailUrl'],
                additionalProperties: false
            }
        },
        required: ['type', 'subType', 'key', 'timestamp', 'metadata'],
        additionalProperties: false
    };
    CommunityMemberBannedEvent.validate = (0, validation_1.generateLazyValidator)(CommunityMemberBannedEvent.schema);
})(CommunityMemberBannedEvent = exports.CommunityMemberBannedEvent || (exports.CommunityMemberBannedEvent = {}));
var CommunityMemberRemovedEvent;
(function (CommunityMemberRemovedEvent) {
    CommunityMemberRemovedEvent.schema = {
        type: 'object',
        properties: {
            type: { type: 'string', const: base_1.Events.Type.COMMUNITY },
            subType: { type: 'string', const: base_1.Events.SubType.Community.MEMBER_REMOVED },
            key: { type: 'string' },
            timestamp: { type: 'number', minimum: 1 },
            metadata: {
                type: 'object',
                properties: {
                    id: { type: 'string' },
                    name: { type: 'string' },
                    memberAddress: { type: 'string' },
                    thumbnailUrl: { type: 'string' }
                },
                required: ['id', 'name', 'memberAddress', 'thumbnailUrl'],
                additionalProperties: false
            }
        },
        required: ['type', 'subType', 'key', 'timestamp', 'metadata'],
        additionalProperties: false
    };
    CommunityMemberRemovedEvent.validate = (0, validation_1.generateLazyValidator)(CommunityMemberRemovedEvent.schema);
})(CommunityMemberRemovedEvent = exports.CommunityMemberRemovedEvent || (exports.CommunityMemberRemovedEvent = {}));
//# sourceMappingURL=communities.js.map